import { isAdminSite } from '~/utils';
import useLearnerHeaderOffset from './LearnerHeader/useHeaderOffset';
import useAdminHeaderOffset from './AdminHeader/useHeaderOffset';

export default function useHeader() {
  const learnerHeaderOffset = useLearnerHeaderOffset();
  const adminHeaderOffset = useAdminHeaderOffset();
  return isAdminSite() ? adminHeaderOffset : learnerHeaderOffset;
}
